import { DatePipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject, takeUntil } from "rxjs";
import { DatePickerModel } from "src/app/components/date-picker-dialog/date-picker.model";
import { HeaderService } from "src/app/components/header/header.service";
import { SnackbarComponent } from "src/app/components/snackbar/snackbar.component";
import { GridActionsService } from "src/app/data-grid/grid-actions.service";
import { DashboardService } from "src/app/services/dashboard.service";
import { ReportsService } from "src/app/services/reports.service";

@Component({
  selector: "app-kpis-graph",
  templateUrl: "./kpis-graph.component.html",
  styleUrls: ["./kpis-graph.component.scss"],
})
export class KpisGraphComponent implements OnInit, OnDestroy {
  @Input() isDashboard: boolean = false;
  mixedChartColor: any[]= ["#e26062","#f5c827","#bfddb7","#3762ff","#cb0af1","#644a00","#b2efdd","#c5d39e","#e7c69d","#9fd0cd"];
  leftLagend: any[] = [
    { id: 1, name: "Spent" },
    { id: 2, name: "Profit" },
    { id: 3, name: "COGS" },
    { id: 4, name: "Fees" },
    { id: 5, name: "Return Amount" },
  ];
  rightLagend: any[] = [
    { id: 6, name: "Margin" },
    { id: 7, name: "ROI" },
    { id: 8, name: "ACOS" },
    { id: 9, name: "TACOS" },
    { id: 10, name: "Return %" },
  ];
  kpiPerDay: any[] = [];
  mixedChartLabel;
  mixedChartData: any[];
  tickInterval: any[] =[];
  showHideChartData:any[] = [];
  currentDateFilter: DatePickerModel;
  dialogRef: any;
  spin: any;
  private destroy$ = new Subject<void>();
  startDate;
  endDate
  
  constructor(
    private reportService : ReportsService,
    private gridActionService: GridActionsService,
    private headerService: HeaderService,
    private dashboardService: DashboardService,
     private datePipe:DatePipe,
     private snackBar: MatSnackBar) {
      this.dashboardService.selectedDate$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
        if (res && res.isKpiSalesGraph) {
          this.startDate = res.startDate;
           this.endDate = res.endDate;
          this.spin = res?.spinner;
          this.dialogRef = res?.dialogRef;
          this.KpiPerDay()
        }
      })
    }
    
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    const today = new Date();
    this.currentDateFilter={
      to: today,
      from:new Date(today.getTime() - this.getDaysAgo(90)),
      label:'Last 90 Days'
    }
  }

  KpiPerDay(){
    let payload : any ={}
    if(this.isDashboard){
      payload ={
        dateFrom :  new Date(new Date().getTime() - this.getDaysAgo(30)),
        dateTo : new Date(),
      }
    } else{
      payload={
        dateFrom : this.datePipe.transform(this.startDate, 'yyyy-MM-ddT00:00:00'),
        dateTo : this.datePipe.transform(this.endDate, 'yyyy-MM-ddT23:59:59'),
      }
    }
    this.reportService.KpiPerDay(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any[]) => {
        this.kpiPerDay = res;
        this.spin =false;
        this.dialogRef?.close();
        this.mixedChartLabel = this.kpiPerDay.map((t) => t.date.substring(0, 10)).filter((x) => x != null);
        this.bindGraph();
      },
     error: (err) => {
      this.spin =false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title:err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        });
     }
   });
  }

  bindGraph(){
    this.mixedChartData = [
      {
        type: 'spline',
        name: 'Spent',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.ppcSpent).filter((x) => x != null),     
      },
      {
        type: 'spline',
        name: 'Profit',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.orders).filter((x) => x != null),
      },
      {
        type: 'spline',
        name: 'COGS',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.salesCogs).filter((x) => x != null),
      },
      {
        type: 'spline',
        name: 'Fees',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => Math.abs(t.salesFees)).filter((x) => x != null),
      },
      {
        type: 'spline',
        name: 'Return Amount',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.qtyReturned).filter((x) => x != null),
      },
      {
        type: 'spline',
        name: 'Margin',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.margin).filter((x) => x != null),
        yAxis: 1
      },
      {
        type: 'spline',
        name: 'ROI',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.roi).filter((x) => x != null),
        yAxis: 1
      },
      {
        type: 'spline',
        name: 'ACOS',
        showInLegend: false,
        data: this.kpiPerDay.map((t) => t.ppcAcos).filter((x) => x != null),
        yAxis: 1
      },
      {
        type: 'spline',
        name: 'TACOS',
        showInLegend: false,
        data:  this.kpiPerDay.map((t) => t.ppcTacos).filter((x) => x != null),
        yAxis: 1
      },
      {
        type: 'spline',
        name: 'Return %',
        showInLegend: false,
        data:  this.kpiPerDay.map((t) => t.returnRate).filter((x) => x != null),
        yAxis: 1
      }

    ]
    let tickIntervalOneArray = [
      "ppcSpent",
      "orders",
      "salesCogs",
      "salesFees",
      "qtyReturned",
    ];
    let tickIntervalSecondArray = [
      "margin",
      "roi",
      "ppcAcos",
      "ppcTacos",
      "returnRate",
    ];
    let tickIntervalOneData: any[] = [];
    let tickIntervalSecondData: any[] = [];
    tickIntervalOneArray.forEach((res) => {
      tickIntervalOneData.push(
        this.kpiPerDay
          .map((t) => {
            return {
              data: t[res],
            };
          })
          .filter((x) => x != null)
      );
    });
    tickIntervalSecondArray.forEach((res) => {
      tickIntervalSecondData.push(
        this.kpiPerDay
          .map((t) => {
            return {
              data: t[res],
            };
          })
          .filter((x) => x != null)
      );
    });
    this.tickInterval.push(
      this.gridActionService.setTickInterval(tickIntervalOneData, 8, true)
    );
    this.tickInterval.push(
      this.gridActionService.setTickInterval(tickIntervalSecondData, 8, true)
    );
  }

  set(i:any, event, index?) {
    i = index ? i + 5 : i;
    let idx = this.showHideChartData?.findIndex((res) => res == this.mixedChartData[i].name);
    idx == -1 ? this.showHideChartData.push(this.mixedChartData[i].name) : this.showHideChartData.splice(idx,1)
    this.headerService.hideLine.next({showHideChartData:this.showHideChartData,chartId:"mixedChartID"});
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

}
